import React from "react";
import { Form, Select } from "antd";
import styled from "styled-components";
import { Box } from "reflexbox/styled-components";
import { getIn } from "formik";

const FormItem = Form.Item;
const { Option } = Select;

const StyledField = styled(Box)`
    .ant-form-item-children-icon {
        display: none;
    }
    .ant-form-item {
        margin-bottom: ${({ theme }) => theme.space[2]}px;
    }

    .ant-form-item label {
        color: ${({ theme }) => theme.colors.white};
    }
    .ant-form-item-children > input {
        color: ${({ theme }) => theme.colors.primary};
        height: 40px;
        ${({ theme }) => theme.mediaQueries.small} {
            height: 45px;
        }
        ${({ theme }) => theme.mediaQueries.medium} {
            height: 50px;
        }
    }

    .ant-form-explain {
        font-weight: ${({ theme }) => theme.fontWeights.light};
        padding-left: ${({ theme }) => theme.space[1]}px;
        height: auto;
        color: ${({ theme }) => theme.colors.white};
        background-color: ${({ theme }) => theme.colors.error};
        border-radius: 3px;
        margin-top: 1px;
    }

    .ant-form-item-label {
        font-weight: ${({ theme }) => theme.fontWeights.light};
        padding-left: ${({ theme }) => theme.space[1]}px;
        padding-top: ${({ theme }) => theme.space[1]}px;
    }
`;

export const withAntComponent =
    AntComponent =>
    ({ field, form, hasFeedback, label, selectOptions, submitCount, type, onChange, numberInput, onBlur, meta, ...props }) => {
        const submitted = submitCount > 0;
        const touched = getIn(form.touched, field.name);
        const hasError = getIn(form.errors, field.name);
        const submittedError = hasError && submitted;
        const touchedError = hasError && touched;

        function isString(s) {
            return s.constructor === String;
        }

        const onInputChange = e => {
            if (isString(e)) {
                form.setFieldValue(field.name, e);
                return;
            } else {
                let val = e.target.value;
                let value = e.target.value;
                if (numberInput) {
                    const lastCharacter = value.slice(-1);
                    val = Number(lastCharacter) >= 0 && Number(lastCharacter) <= 9 ? value : value.slice(0, value.length - 1);
                }
                form.setFieldValue(field.name, val);
            }
        };
        return (
            <StyledField className="field-container" sx={{ mx: [3, 4], my: [2, 3], px: [1, 2], pt: [1, 2] }}>
                <FormItem
                    hasFeedback={!!((hasFeedback && submitted) || (hasFeedback && touched))}
                    help={submittedError || touchedError ? hasError : false}
                    validateStatus={submittedError || touchedError ? "error" : "success"}>
                    <AntComponent {...field} placeholder={label} {...props} onBlur={onBlur} onChange={type ? onChange : onInputChange}>
                        {selectOptions && selectOptions.map(name => <Option key={name}>{name}</Option>)}
                    </AntComponent>
                </FormItem>
            </StyledField>
        );
    };
